import { Component, OnDestroy, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DataService_PortalAppNotificationLog } from "./shared/data.service";
import { NotificationReportRequest } from "./shared/notification-report-request";
import * as moment from "moment";

@Component({
	selector: "app-portal-app-notification-log",
	templateUrl: "./portal-app-notification-log.component.html",
	styleUrls: ["./portal-app-notification-log.component.css"],
})
export class PortalAppNotificationLogComponent implements OnInit, OnDestroy {
	constructor(private selectService: SchoolselectorService, private dataService: DataService_PortalAppNotificationLog) {}

	ngOnInit(): void {
		this.loadRegAppType();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		try {
			this.subscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
	}

	/////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////

	subscription: any;

	SelectedSchool: any;
	SchoolSelectShowAllID: number = -1;
	SchoolSelectShowAllText: string = "All Schools";

	RegAppTypeID: number = -1;
	lstRegAppType: any = [];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	GradeLevelID: number = -1;
	lstGradeLevel: any = [];

	HomeroomID: number = -1;
	lstHomeroom: any = [];

	AcademyID: number = -1;
	lstAcademy: any = [];

	GroupID: number = -1;
	lstGroup: any = [];

	ActiveOptionID: number = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	SelectedNotification: any;
	lstNotifications: any = [];

	// Filter Lists
	lstSchoolName: any = [];
	lstAppDesc: any = [];
	lstNotificationTypeDesc: any = [];
	lstNotificationQueueStatusDesc: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	LoadingRegAppType: boolean = false;
	LoadingGradeLevel: boolean = false;
	LoadingHomeroom: boolean = false;
	LoadingAcademy: boolean = false;
	LoadingGroup: boolean = false;
	LoadingNotifications: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	ShowID: boolean = false;
	ShowFirstName: boolean = true;
	ShowLastName: boolean = true;
	ShowSchoolName: boolean = false;
	ShowAppDesc: boolean = true;
	ShowNotificationTypeDesc: boolean = true;
	ShowNotificationQueueStatusDesc: boolean = true;
	ShowUserID_Email: boolean = true;
	ShowUserFirstName: boolean = false;
	ShowUserLastName: boolean = false;
	ShowLogDT: boolean = true;
	ShowContentTitle: boolean = true;
	ShowContentText: boolean = true;

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////

	loadRegAppType() {
		this.LoadingRegAppType = true;

		var result = this.dataService.RegAppTypeSelectList();
		result.subscribe(
			(response) => {
				this.LoadingRegAppType = false;
				this.lstRegAppType = response;

				this.lstRegAppType.unshift({
					RegAppTypeID: -1,
					RegAppTypeDesc: "All",
				});

				this.RegAppTypeID = this.lstRegAppType[0].RegAppTypeID;
			},
			(error) => {
				this.LoadingRegAppType = false;
			}
		);
	}

	loadGradeLevel() {
		this.LoadingGradeLevel = true;

		var result = this.dataService.GradeLevelSelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingGradeLevel = false;
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grades",
					});
				}

				this.GradeLevelID = this.lstGradeLevel[0].GradeLevelID;

				this.loadHomeroom();
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	loadHomeroom() {
		this.LoadingHomeroom = true;

		var result = this.dataService.HomeroomSelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingHomeroom = false;
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomID: -1,
						HomeroomDesc: "All Homerooms",
					});
				}

				this.HomeroomID = this.lstHomeroom[0].HomeroomID;

				this.loadAcademy();
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.dataService.AcademySelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingAcademy = false;
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyID: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.AcademyID = this.lstAcademy[0].AcademyID;

				this.loadGroup();
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadGroup() {
		this.LoadingGroup = true;

		var result = this.dataService.GroupSelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingGroup = false;
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupDesc: "All Groups",
					});
				}

				this.GroupID = this.lstGroup[0].GroupID;

				this.loadNotifcations();
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	loadNotifcations() {
		this.LoadingNotifications = true;

		if (
			this.SelectedSchool == undefined ||
			this.SelectedSchool.SchoolID == undefined ||
			this.GradeLevelID == undefined ||
			this.AcademyID == undefined ||
			this.HomeroomID == undefined ||
			this.GroupID == undefined ||
			this.RegAppTypeID == undefined ||
			this.StartDate == undefined ||
			this.EndDate == undefined
		) {
			return;
		}

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			// this.errorMessage = "Invalid Start Date";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			// this.errorMessage = "Invalid End Date";
			return;
		}

		var parms: NotificationReportRequest = {
			SchoolID: this.SelectedSchool.SchoolID,
			GradeLevelID: this.GradeLevelID,
			AcademyID: this.AcademyID,
			HomeroomID: this.HomeroomID,
			GroupID: this.GroupID,
			Active: this.ActiveOptionID,
			RegAppTypeID: this.RegAppTypeID,
			StartDate: fsDate,
			EndDate: feDate,
		};

		var result = this.dataService.NotificationLogSelectList(parms);
		result.subscribe(
			(response) => {
				this.LoadingNotifications = false;
				this.lstNotifications = response;

				this.lstSchoolName = Array.from(new Set(this.lstNotifications.map((item: any) => item.SchoolName))).sort();
				this.lstAppDesc = Array.from(new Set(this.lstNotifications.map((item: any) => item.AppDesc))).sort();
				this.lstNotificationTypeDesc = Array.from(new Set(this.lstNotifications.map((item: any) => item.NotificationTypeDesc))).sort();
				this.lstNotificationQueueStatusDesc = Array.from(new Set(this.lstNotifications.map((item: any) => item.NotificationQueueStatusDesc))).sort();
			},
			(error) => {
				this.LoadingNotifications = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadNotifcations();
	}

	onShowAll() {
		this.ShowID = true;
		this.ShowFirstName = true;
		this.ShowLastName = true;
		this.ShowSchoolName = true;
		this.ShowAppDesc = true;
		this.ShowNotificationTypeDesc = true;
		this.ShowNotificationQueueStatusDesc = true;
		this.ShowUserID_Email = true;
		this.ShowUserFirstName = true;
		this.ShowUserLastName = true;
		this.ShowLogDT = true;
		this.ShowContentTitle = true;
		this.ShowContentText = true;
	}

	onResetShowOptions() {
		this.ShowID = false;
		this.ShowFirstName = true;
		this.ShowLastName = true;
		this.ShowSchoolName = false;
		this.ShowAppDesc = true;
		this.ShowNotificationTypeDesc = true;
		this.ShowNotificationQueueStatusDesc = true;
		this.ShowUserID_Email = true;
		this.ShowUserFirstName = false;
		this.ShowUserLastName = false;
		this.ShowLogDT = true;
		this.ShowContentTitle = true;
		this.ShowContentText = true;
	}

	onClearShowOptions() {
		this.ShowID = false;
		this.ShowFirstName = false;
		this.ShowLastName = false;
		this.ShowSchoolName = false;
		this.ShowAppDesc = false;
		this.ShowNotificationTypeDesc = false;
		this.ShowNotificationQueueStatusDesc = false;
		this.ShowUserID_Email = false;
		this.ShowUserFirstName = false;
		this.ShowUserLastName = false;
		this.ShowLogDT = false;
		this.ShowContentTitle = false;
		this.ShowContentText = false;
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Sent for Student/Staff ID",`;
		DataStr += `"Sent for First Name",`;
		DataStr += `"Sent for Last Name",`;
		DataStr += `"School",`;
		DataStr += `"App",`;
		DataStr += `"Notification Type",`;
		DataStr += `"Status",`;
		DataStr += `"Recipient Email",`;
		DataStr += `"Recipient First Name",`;
		DataStr += `"Recipient Last Name",`;
		DataStr += `"Date/Time",`;
		DataStr += `"Title",`;
		DataStr += `"Message",`;
		DataStr += "\n";

		for (var z = 0; z < this.lstNotifications.length; z++) {
			var next = this.lstNotifications[z];

			DataStr += `"` + next.ID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.SchoolName + `",`;
			DataStr += `"` + next.AppDesc + `",`;
			DataStr += `"` + next.NotificationTypeDesc + `",`;
			DataStr += `"` + next.NotificationQueueStatusDesc + `",`;
			DataStr += `"` + next.UserID_Email + `",`;
			DataStr += `"` + next.UserFirstName + `",`;
			DataStr += `"` + next.UserLastName + `",`;
			DataStr += `"` + next.LogDTDesc + `",`;
			DataStr += `"` + next.ContentTitle + `",`;
			DataStr += `"` + next.ContentText + `",`;

			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>
		var FileName = "PortalNotificationLog";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadGradeLevel();
	}

	onRegAppTypeIDChange(val) {
		this.RegAppTypeID = val;

		this.loadNotifcations();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadNotifcations();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadNotifcations();
	}

	onGradeLevelIDChange(val) {
		this.GradeLevelID = val;

		this.loadNotifcations();
	}

	onHomeroomIDChange(val) {
		this.HomeroomID = val;

		this.loadNotifcations();
	}

	onAcademyIDChange(val) {
		this.AcademyID = val;

		this.loadNotifcations();
	}

	onGroupIDChange(val) {
		this.GroupID = val;

		this.loadNotifcations();
	}

	onActiveOptionIDChange(val) {
		this.ActiveOptionID = val;

		this.loadNotifcations();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedNotification = val.data;
	}
	onRowUnselect(val) {
		this.SelectedNotification = null;
	}

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return (
			this.LoadingRegAppType == true ||
			this.LoadingGradeLevel == true ||
			this.LoadingHomeroom == true ||
			this.LoadingAcademy == true ||
			this.LoadingGroup == true ||
			this.LoadingNotifications == true ||
			this.Processing == true
		);
	}

	ShowStudentOptions() {
		if (this.RegAppTypeID == undefined) {
			return false;
		}
		if (this.RegAppTypeID == 1 || this.RegAppTypeID == 2) {
			return true;
		} else {
			return false;
		}
	}

	/////////////////////////////////////////////////////////////////////////////
}
